<template>
  <v-container fluid>
    <!-- Header -->

    <v-card>
      <CaseReportHeader :caseReport="caseReport" :backButton="true"/>
    </v-card>
    <!-- Body -->
    <CaseReportBody :caseReport="caseReport" />
  </v-container>
</template>

<script>
import CaseReportBody from "../components/CaseReportBody";
import CaseReportHeader from "../components/CaseReportHeader.vue"
export default {
  name: "CaseReportFullScreen",
  components: {
    CaseReportBody, CaseReportHeader
  },
  data() {
    return {};
  },
  props: {
    caseReport: {},
  },
  methods: {
  },
  async created() {
    /**
     * This view can be created from both Search & Resolution.
     * From Search, address & passport will always be null, but Edit Case modal expects non null
     */
    // if (!this.caseReport.searchCase.address) {
    //   this.caseReport.searchCase.address = {};
    // }
    // if (!this.caseReport.searchCase.passport) {
    //   this.caseReport.searchCase.passport = {};
    // }
  },
};
</script>

<style>
</style>